<template>
  <div class="about">
       <!-- Navigation -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" id="mainNav">
            <div class="container">
            <router-link :to="{name: 'Home', hash:'#page-top'}" class="navbar-brand js-scroll-trigger"><img src="@/assets/img/navbar-logo5.png" alt="" /></router-link> 
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#bar'}" class="nav-link js-scroll-trigger text-uppercase">unser lokal</router-link>    <!--<a class="nav-link js-scroll-trigger text-uppercase" href="#bar">unser lokal</a>-->
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#menus'}" class="nav-link js-scroll-trigger text-uppercase">Menus</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#handl'}" class="nav-link js-scroll-trigger text-uppercase">Öffnungszeiten & Anfahrt</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#contact'}" class="nav-link js-scroll-trigger text-uppercase">Kontakt</router-link>
                    </li>
                    </ul>
                </div>
            </div>
        </nav>
        <!-- Topunsub -->
        <Topunsub></Topunsub>

        <!-- Footer-->
        <Down></Down>
 </div>

 
</template>

<script src='https://www.google.com/recaptcha/api.js'></script> 

<script>
import Topunsub from '@/components/topunsub.vue'
import Down from '@/components/down.vue'

export default {
  name: 'App',
  components: {
    Topunsub,
    Down
  },

  data(){
    return{
        isHidden: true,
        successes: [],
        errors: [],

        name: null,
        email: null,
        phone: null,
        message: null,

        error_name: [],
        error_email: [],
        error_phone: [],
        error_message: [],
    }
  },

    methods: {
    checkForm: function (event) {
      this.errors = [];
      this.successes = [];
      this.error_name = [];
      this.error_email = [];
      this.error_phone = [];
      this.error_message = [];

      if(!this.name){
        this.error_name.push('Bitte gib deinen Namen ein.');
      } 
      if (!this.email) {
        this.error_email.push('Bitte gib deine Email Adresse ein.');
      } else if (!this.validEmail(this.email)) {
        this.error_email.push('Bitte gib eine gültige Email Adresse ein.');
      }
      if (!this.phone){
        this.error_phone.push('Bitte gib eine Telefonnumer ein.');
      }
      if (!this.message) {
        this.error_message.push('Bitte gib eine Nachricht ein.');
      }

      if (!this.error_name.length && !this.error_email.length && !this.error_phone.length && !this.error_message.length) {
        let recaptcha_response_value = event.target['g-recaptcha-response'].value;
        var data = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          message: this.message,
          g_recaptcha_response: recaptcha_response_value,
        };
        this.sendContactForm(data)
      } 
    },

    sendContactForm: function(data){
        fetch("https://api.barriere.mgassler.ch/conreg/delnew", {
          method: 'post',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          this.isHidden = true
          this.name = ""
          this.email = ""
          this.phone = ""
          this.message = ""
          grecaptcha.reset();
          const resdata = response.data
          alert(response);
          this.successes.push('Danke, Wir werden uns in kürze bei dir melden.');

        })
        .catch(() => {
          this.isHidden = true
          this.errors.push('Sorry, es scheint, dass mein Mailserver nicht antwortet. Bitte versuche es später noch einmal!');
        });
    },

    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  }
}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.mascontainer {
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;
  background: rgba(78, 78, 77, 0.39);
}

header.masthead {
  padding-top: 0rem;
  padding-bottom: 0rem;
  text-align: center;
  color: #fff;
  background-image: url("../assets/img/header-close-bg.jpg");
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  background-size: cover;
}
</style>
